<template>
<div class="headerwrap">
    <TopHeader v-if="isDmg"></TopHeader>
    <div class="header">
      <div class="menu-box">
        <div
          class="menu-item"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <a v-if="index === 5 && !_myData.showFaq" @click="faqNoOpen" class="miao"></a>
          <router-link v-if="index === 5 && _myData.showFaq" class="miao" :to="`${isOriginDmg || isDmg?'/dmg':'/home'}#section${index+1}`"></router-link>
          <router-link v-if="index !== 5" class="miao" :to="`${isOriginDmg || isDmg?'/dmg':'/home'}#section${index+1}`"></router-link>
          <span :class="[`m${index + 1}`, activeIndex == index ? 'active' : '']"></span
        ></div>
      </div>
      <img class="logo" src="@/assets/images/logo.png" alt="" />
      <div class="icon-box">
        <img
          @click="jump(item.url, index)"
          class="icon"
          v-for="(item, index) in isDmg? _myData.dmg_headIconList:_myData.headIconList"
          :key="index"
          :src="item.icon"
          alt=""
        />
      </div>
    </div>
</div>
</template>

<script>
import TopHeader from "@/components/pc/TopHeader";
import { mapState } from "vuex";
import { setCookie, getCookie } from "@/util/index"

export default {
  components: { TopHeader },
  data() {
    return {
      menuList: [
        "ホーム",
        "ニュース",
        "世界観",
        "キャラクター",
        "システム",
        "FAQ",
      ],
      activeIndex: 0,
      tempIndex: -1,
      secHeight: 0,

      secPercentHeight: 0,

    };
  },
  computed: {
    ...mapState(["_myData"]),
    sectionHeight () {
      return 1080 - window.innerHeight
    },
    isDmg() {
      return this.$route.name === 'dmg'
    },
    isOriginDmg() {
      return this.$route.query.origin === 'dmg'
    }
  },
  created () {
    if(this.$route.name == 'protocol') {
      this.activeIndex = -1;
    }

    if (this.$route.name == 'news' || this.$route.name == 'detail') {
      this.activeIndex = 1
    }

    if (this.$route.name == 'detail') {
      this.activeIndex = 1
      if (this.$route.query.id == 'faq') {
        this.activeIndex = 5
      }
    }
  },
  mounted() {

    this.setDomFn()
    window.addEventListener("resize", ()=>{
      this.setDomFn(1)
    }, false);


    if (getCookie('scrolltop')) {
      window.scrollTo({
        top: getCookie('scrolltop')
      });
    }
    window.addEventListener("scroll", this.debounce(this.scrollFn), false);

  },
  methods: {

    setDomFn(num) {
      const oSection = document.querySelector('#section3');
      if (oSection) {
        this.secHeight = this.getDomType(oSection, 'height');
        if (num) {
          window.scrollTo({
            top: (this.activeIndex + this.secPercentHeight) * this.secHeight,
            // behavior: 'smooth'
          });
        }
      }
    },

    faqNoOpen() {
      layer.open({
        content: 'まだ公開されていません。しばらくお待ちください。',
        time: 2,
        skin: 'msg'
      })
    },

    // jumpHash (index, hash) {
    //   this.tempIndex = index;
    //   if (this.$route.name == 'home' || this.$route.name == 'dmg') {
    //     if (index == 5 && !this._myData.showFaq) {
    //       layer.open({
    //         content: 'まだ公開されていません。しばらくお待ちください。',
    //         time: 2,
    //         skin: 'msg'
    //       })
    //       return false
    //     }
    //   } else {
    //     const origin = this.$route.query.origin || '';
    //     this.$router.push({name: origin, query: {index}})
    //   }
    // },
    jump(url, index) {
      window.open(url);
    },
    debounce(fn) {
      return () => {
        if (this.timeout !== null) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(fn, 20);
      };
    },
    scrollFn() {
      if (this.$route.name == 'home' || this.$route.name == 'dmg') {
        const scrolltop = this.getScrollTop();
        // this.activeIndex = parseInt((scrolltop + (this.secHeight - window.innerHeight)) / this.secHeight);
        this.activeIndex = parseInt(scrolltop / this.secHeight);

        // head点击的index传给 activeIndex
        if (this.tempIndex != -1) {
          this.activeIndex = this.tempIndex;
          this.tempIndex = -1;
        }

        setCookie('scrolltop', scrolltop)

        // 滚动到当前模块的比例

        const perHeight = (scrolltop - this.activeIndex * this.secHeight) / this.secHeight
        this.secPercentHeight = Number(perHeight.toFixed(2)) > 0 ? Number(perHeight.toFixed(2)) : 0
        if (this.secPercentHeight > 0.9) {
          this.secPercentHeight = 0;
          this.activeIndex++
        }
      }
    },
    getScrollTop() {
      var scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
    getDomType(dom, style) {
      const styles = this.getStyle(dom, style);
      const height = styles.slice(0, styles.length -2);
      return Number(height);
    },
    // 获取样式
    getStyle(el, attr) {
        if (el && el.currentStyle) {
          // IE,OPER
          return el.currentStyle[attr]
        } else {
          // chrome、safari、FireFox
          return window.getComputedStyle(el)[attr]
        }
    },

  },
};
</script>

<style lang="scss" scope>
.headerwrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.header {
  position: relative;
  height: 80px;
  background: rgba(7, 16, 35, 0.8);
  z-index: 100;
  min-width: 1280px;
  .logo {
    // width: 288px;
    width: 15%;
    position: absolute;
    // right: 1580px;
    // top: 15px;
    right: 82.29%;
    top: 20%;
    @media screen and (max-width: 1800px) {
      // right: 1500px;
    }
    @media screen and (min-width: 1920px) {
      left: 55px;
      right: auto;
    }
  }

  @media screen and (max-width: 1280px) {
    margin-left: 50%;
    transform: translateX(-50%);
  }
}

.menu-box {
  height: 100%;
  display: flex;
  justify-content: center;
  margin: auto;
  align-items: center;
  font-size: 20px;
  // transform: translateX(-60px);
  .menu-item {
    color: #fff;
    // width: 190px;
    width: 10%;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    height: 27px;
    // @include bg('headicon.png');
    @include vc;
    position: relative;
    .miao {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      outline: none;
      cursor: pointer;
    }
    span {
      display: block;
      background-image: url("./../../../src/assets/images/headicon.png");
      background-repeat: no-repeat;
      @include pointer;
    }

    .m1 {
      height: 31px;
      width: 61px;
      background-position: 0 -46px;

      &:hover,
      &.active {
        background-position: 0 -77px;
      }
    }

    .m2 {
      height: 31px;
      width: 82px;
      background-position: 0 -240px;


      &:hover,
      &.active {
        background-position: 0 -271px;
      }
    }

    .m3 {
      height: 34px;
      width: 66px;
      background-position: 0 -142px;

      &:hover,
      &.active {
        background-position: 0 -108px;
      }
    }

    .m4 {
      height: 32px;
      width: 69px;
      background-position: 0 -176px;

      &:hover,
      &.active {
        background-position: 0 -208px;
      }
    }

    .m5 {
      height: 32px;
      width: 82px;
      background-position: 0 -302px;

      &:hover,
      &.active {
        background-position: 0 -334px;
      }
    }

    .m6 {
      height: 23px;
      width: 45px;
      background-position: 0 0;

      &:hover,
      &.active {
        background-position: 0 -23px;
      }
    }

    &:not(:last-child) {
      border-right: 1px solid rgba(255, 255, 255, 0.24);
    }
  }
}

.icon-box {
  display: flex;
  position: absolute;
  right: 115px;
  top: 0;
  height: 80px;
  align-items: center;
  transition: all 0.5s ease;

  @media screen and (max-width: 1500px) {
    transform: translateX(80px);
  }

  @media screen and (max-width: 1300px) {
    // display: none;
  }

  .icon {
    width: 34px;
    @include pointer;

    &:not(:last-child) {
      margin-right: 31px;
    }
  }
}

</style>
